import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import auth from './auth'
import branchSearch from './branchSearch'
import branchSelector from './branchSelector'
import countries from './countries'
import customer from './customer'
import customers from './customers'
import dashboard from './dashboard'
import groups from './groups'
import locations from './locations'
import organizations from './organizations'
import messages from './messages'
import server from './server'
import servers from './servers'
import user from './user'
import users from './users'
import resetPassword from './resetPassword'
import forgotPassword from './forgotPassword'
import timepick from './timepick'
import token from './token'

const reducers = combineReducers({
    auth,
    branchSearch,
    branchSelector,
    countries,
    customer,
    customers,
    dashboard,
    forgotPassword,
    form: formReducer,
    groups,
    locations,
    organizations,
    messages,
    resetPassword,
    server,
    servers,
    timepick,
    token,
    user,
    users,
});

export default reducers;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js